import {useCallback, useContext, useMemo} from "react";
import {GlobalContext} from "@tools/globalContext";
import {IMainMenuDecorator} from "@tools/CustomInterfaces";
import useUserRights from "@hooks/useUserRights";

interface Props {
    decorator: IMainMenuDecorator[],
}

const useNotificationsCount = (props : Props) => {
    const {decorator} = props;
    const { user, notifications } = useContext(GlobalContext);
    const {navigatorVisibility} = useUserRights();

    const visibleBranches = useMemo(() => {
        return decorator.filter(page => navigatorVisibility(page))
    }, [user, decorator])

    const getNotificationsCount = useCallback((menuId: string) : number => {

        const findBranchCount = (items: any, collectChildrenNotifications: boolean) => {
            let count = 0
            for(const branch of items) {
                let foundBranchStart = false
                if (branch.id === menuId) {
                    if (branch.notifications)
                        count += notifications?.[branch.notifications]?.count || 0
                    foundBranchStart = true
                }
                else if (collectChildrenNotifications && branch.notifications) {
                    count += notifications?.[branch.notifications]?.count || 0
                }

                if (branch.children) {
                    count += findBranchCount(branch.children.filter((page: any) => navigatorVisibility(page)), foundBranchStart || collectChildrenNotifications)
                }
            }

            return count
        }

        return findBranchCount(visibleBranches, false)
    }, [notifications, visibleBranches])

    return {getNotificationsCount}
}

export default useNotificationsCount
